document.addEventListener("DOMContentLoaded", function () {
  // Failsafe for external links added in WYSIWYG editors
  // Select all <a> tags with target="_blank"
  const links = document.querySelectorAll('a[target="_blank"]');

  // Loop through the links and add the class only if no class is already present
  links.forEach(function (link) {
    if (!link.classList.length) {
      link.classList.add("link-external");
      const link_content = link.innerHTML;
      link.innerHTML = `<span>${link_content}</span>`;
    }
    // Add aria-label for good accessibility practice
    if (!link.hasAttribute("aria-label")) {
      link.setAttribute("aria-label", "Opens in a new tab");
    }
  });

  // Adds external link styling to external cyto link in footer
  let externalNavLinks = document.querySelectorAll(
    ".link-external > .nav-link"
  );
  externalNavLinks.forEach(function (link) {
    link.classList.add("link-external");
    const link_content = link.innerHTML;
    link.innerHTML = `<span>${link_content}</span>`;
  });
});
